import { Tag } from 'primereact/tag';
import { classNames } from 'primereact/utils';
import { useTranslation } from 'react-i18next';

import { CertificateTaskStatus as CertificateTaskStatusEnum } from '../../../../../../../../shared/interfaces/ICertificateTask';
import styles from './CertificateTaskStatus.module.css';

const determineTagClass = (status: CertificateTaskStatusEnum) => {
  switch (status) {
    case CertificateTaskStatusEnum.Completed:
      return styles['complete-tag'];
    case CertificateTaskStatusEnum.Pending:
      return styles['pending-tag'];
    default:
      return '';
  }
};

type CertificateTaskStatusProps = {
  status: CertificateTaskStatusEnum;
};

const CertificateTaskStatus = ({ status }: CertificateTaskStatusProps): JSX.Element => {
  const { t } = useTranslation();

  const tagClass = determineTagClass(status);
  const text = t(`tasksPage.tabs.certificateTasksTab.statuses.${status}`);

  return (
    <Tag rounded className={classNames('text-sm font-medium px-2 py-1', tagClass)}>
      {text}
    </Tag>
  );
};

export default CertificateTaskStatus;
